import { getWsInterface, UNNAMED_WS_HANDLER_SCOPE } from '../../spa/Utils/Websockets';
const WS_PREPLAY_CONNECTION_NAME = 'preplay';
export const WS_PREPLAY_START_ACTION = 'inplay_start';
export const WS_PREPLAY_OFF_ACTION = 'event_off';
export const WS_PREPLAY_UPDATE_ACTION = 'price_update';

/**
 * @deprecated use mainSocketClass instead
 */

const wsInterface = getWsInterface();

/**
 * Sets if the handlers have been set or not
 * @type {Boolean}
 */
let isPreplayEventHandlersSet = false;

/**
 * A Set holding the list of preplay start event listeners
 * @type {Set}
 */
const preplayEventStartListeners = new Set();

/**
 * A Set holding the list of preplay off event listeners
 * @type {Set}
 */
const preplayEventOffListeners = new Set();

/**
 * A Set holding the list of preplay update event listeners
 * @type {Set}
 */
const preplayEventUpdateListeners = new Set();

/**
 * The preplay event start websocket handler
 * @param  {Array} args The arguments passed from the websocket
 * @return {void}
 */
const preplayEventStartHandler = (...args) => {
    const listeners = Array.from(preplayEventStartListeners);

    listeners.forEach(listener => listener(...args));
};

/**
 * The preplay event off websocket handler
 * @param  {Array} args The arguments passed from the websocket
 * @return {void}
 */
const preplayEventOffHandler = (...args) => {
    const listeners = Array.from(preplayEventOffListeners);

    listeners.forEach(listener => listener(...args));
};

/**
 * The preplay event update websocket handler
 * @param  {Array} args The arguments passed from the websocket
 * @return {void}
 */
const preplayEventUpdateHandler = (...args) => {
    const listeners = Array.from(preplayEventUpdateListeners);

    listeners.forEach(listener => listener(...args));
};

/**
 * A helper to set the websocket handlers
 * @param {String} [wsHandlerScope=UNNAMED_WS_HANDLER_SCOPE] a unique scope for the handler e.g. "RacingWidget-horse-racing"
 * functions (must be unique per page)
 * @todo AM-2540 - probably should deprecate this file - or discourage use - the preplay and inplay handlers
 * will both register price_update handlers
 * @return {void}
 */
const setPreplayEventHandlers = (wsHandlerScope = UNNAMED_WS_HANDLER_SCOPE) => {
    wsInterface.requestHandler(WS_PREPLAY_CONNECTION_NAME).registerHandler(WS_PREPLAY_START_ACTION, preplayEventStartHandler, wsHandlerScope);
    wsInterface.requestHandler(WS_PREPLAY_CONNECTION_NAME).registerHandler(WS_PREPLAY_OFF_ACTION, preplayEventOffHandler, wsHandlerScope);
    wsInterface.requestHandler(WS_PREPLAY_CONNECTION_NAME).registerHandler(WS_PREPLAY_UPDATE_ACTION, preplayEventUpdateHandler, wsHandlerScope);

    isPreplayEventHandlersSet = true;
};

/**
 * Starts listening for preplay event updates
 * @param {Array} events array of {event_id: 1, markets: [2]}
 * @param {String} [wsHandlerScope=UNNAMED_WS_HANDLER_SCOPE] a unique scope for the handler e.g. "RacingWidget-horse-racing"
 * @return {void}
 */
export function startListeningForPreplayEventUpdates(events, wsHandlerScope = UNNAMED_WS_HANDLER_SCOPE) {
    wsInterface.requestHandler(WS_PREPLAY_CONNECTION_NAME).subscribe(events);

    if (!isPreplayEventHandlersSet) {
        wsInterface.onCloseConnections(() => {
            isPreplayEventHandlersSet = false;
        });

        setPreplayEventHandlers(wsHandlerScope);
    }

}

/**
 * Handle on preplay event start
 * @param  {Function} callback A callback that is called with the started event
 * @return {Function} A callback to unsubscribe from the event
 */
export function onPreplayEventStart(callback) {
    preplayEventStartListeners.add(callback);

    return function unsubscribe() {
        preplayEventStartListeners.delete(callback);
    };
}

/**
 * Handle on preplay event off
 * @param  {Function} callback A callback that is called with the offed event
 * @return {Function} A callback to unsubscribe from the event
 */
export function onPreplayEventOff(callback) {
    preplayEventOffListeners.add(callback);

    return function unsubscribe() {
        preplayEventOffListeners.delete(callback);
    };
}

/**
 * Handle on preplay event update
 * @param  {Function} callback A callback that is called with the started event
 * @return {Function} A callback to unsubscribe from the event
 */
export function onPreplayEventUpdate(callback) {
    preplayEventUpdateListeners.add(callback);

    return function unsubscribe() {
        preplayEventUpdateListeners.delete(callback);
    };
}
